import { store } from '../../store'
import { httpgst } from '../../main'

// initial state
const state = {}

// getters
const getters = {}

// actions
const actions = {
  expensesStatus ({ commit, dispatch }, payload) {
    let url = 'api/catalog/gst_expenses_status'
    let options = {
      headers: {
        'Content-Type': 'application/json'
      }
    }
    httpgst.defaults.headers.common['Authorization'] = 'Bearer ' + store.state.userState.access_token
    httpgst.get(url, {}, options)
      .then(
        response => {
          commit('onGetExpensesStatus', { event: payload.event, response: response })
        },
        error => {
          commit('onError', { event: payload.event, error: error })
        }
      )
  },
  receiptTypes ({ commit, dispatch }, payload) {
    let url = 'api/catalog/gst_receipt_types'
    let options = {
      headers: {
        'Content-Type': 'application/json'
      }
    }
    httpgst.defaults.headers.common['Authorization'] = 'Bearer ' + store.state.userState.access_token
    httpgst.get(url, {}, options)
      .then(
        response => {
          commit('onGetReceiptTypes', { event: payload.event, response: response })
        },
        error => {
          commit('onError', { event: payload.event, error: error })
        }
      )
  },
  restrictionTypes ({ commit, dispatch }, payload) {
    let url = 'api/catalog/gst_restriction_types'
    let options = {
      headers: {
        'Content-Type': 'application/json'
      }
    }
    httpgst.defaults.headers.common['Authorization'] = 'Bearer ' + store.state.userState.access_token
    httpgst.get(url, {}, options)
      .then(
        response => {
          commit('onGetRestrictionTypes', { event: payload.event, response: response })
        },
        error => {
          commit('onError', { event: payload.event, error: error })
        }
      )
  }
}

// mutations
const mutations = {
  // Set the data obtained from the catalog
  onGetExpensesStatus (state, payload) {
    payload.event.context.expensesStatus = payload.response.data.data
  },
  // Set the data obtained from the catalog
  onGetReceiptTypes (state, payload) {
    payload.event.context.receiptTypes = payload.response.data.data
  },
  // Set the data obtained from the catalog
  onGetRestrictionTypes (state, payload) {
    payload.event.context.restrictionTypes = payload.response.data.data
  },
  // Shows a error message
  onError (state, payload) {
    if (payload.error.response.status === 401) {
      payload.event.context.showNotification(payload.event.context.$t('login.sessionExpired'), 'error', -1)
      setTimeout(() => { payload.event.context.$router.push({ name: 'LoginPage' }) }, 2000)
    } else {
      payload.event.context.showNotification(payload.error.response, 'error', -1)
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/catalogs.js